import { styled } from '@mui/material/styles';

import { Theme } from '../../theme';
import { ESpotsSlidesColor, ESpotsTextureColor } from '../ESpotsComponent';

export const slideColorTheme = (
    customTheme: Theme,
    slideColor: ESpotsSlidesColor,
) => {
    return {
        'Energy blue': {
            color: customTheme.palette.tgg.text.body.inverse,
            backgroundColor: customTheme.palette.tgg.surface.brand1,
            textureColor:
                slideColor === 'Energy blue'
                    ? customTheme.palette.tgg.graphic.on.brand.subtle3
                    : customTheme.palette.tgg.graphic.on.inverse.subtle2,
        },
        Cyan: {
            color: customTheme.palette.tgg.text.body.main,
            backgroundColor: customTheme.palette.tgg.surface.brand4,
            textureColor: customTheme.palette.tgg.graphic.on.brand.subtle1,
        },
        Navy: {
            color: customTheme.palette.tgg.text.body.inverse,
            backgroundColor: customTheme.palette.tgg.surface.brand3,
        },
        Pink: {
            textureColor: customTheme.palette.tgg.graphic.on.inverse.strong2,
        },
        Purple: {
            textureColor:
                slideColor === 'Energy blue'
                    ? customTheme.palette.tgg.graphic.on.brand.subtle2
                    : customTheme.palette.tgg.graphic.on.inverse.strong4,
        },
        'Electric green': {
            color: customTheme.palette.tgg.text.body.main,
            backgroundColor: customTheme.palette.tgg.surface.brand2,
            textureColor:
                slideColor === 'Electric green'
                    ? customTheme.palette.tgg.graphic.on.attention
                    : customTheme.palette.tgg.graphic.on.brand.strong1,
        },
    };
};

export const StyledContainer = styled('div')`
    ${({
        theme,
        $slideColor,
        $isClickable,
    }: {
        theme: Theme;
        $slideColor: ESpotsSlidesColor;
        $isClickable: boolean;
    }) => {
        const slideTheme = slideColorTheme(theme, $slideColor)[$slideColor];
        return `
            display: flex;
            position: relative;
            box-sizing: content-box;
            justify-content: center;
            align-items: center;
            min-width: ${theme.tggSpacing(36)};
            max-width: ${theme.tggSpacing(36)};
            width: 100%;
            height: ${theme.tggSpacing(14)};
            padding: ${theme.tggSpacing(2)};
            color: ${slideTheme.color};
            background-color: ${slideTheme.backgroundColor};
            border-radius: ${theme.tggSpacing(2)};
            text-decoration: none;
            cursor: ${$isClickable ? 'pointer' : 'default'};

            ${theme.breakpoints.up('desktop')} {
                min-width: ${theme.tggSpacing(54)};
                max-width: ${theme.tggSpacing(54)};
                height: ${theme.tggSpacing(20)};
                padding: ${theme.tggSpacing(4)};
            }
    `;
    }}
`;

export const StyledTitle = styled('div')`
    ${({ theme }) => theme.typography.text_20_bold_lh_22_desktop_25_lh_28_sans};
    z-index: 1;
    text-align: center;
`;

export const StyledTextureWrapper = styled('div')`
    ${({
        theme,
        $slideColor,
        $textureColor,
    }: {
        theme: Theme;
        $slideColor: ESpotsSlidesColor;
        $textureColor: ESpotsTextureColor;
    }) => {
        const slideTheme = slideColorTheme(theme, $slideColor)[$textureColor];
        return `
            position: absolute;
            inset: 0;
            z-index: 0;
            pointer-events: none;

            svg {
                width: 100%;
                height: 100%;
                object-fit: cover;

                path {
                    fill: ${slideTheme?.textureColor} !important
                }
            }
        `;
    }};
`;
